import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a bar stool: round oak seat at 0.65 m on slim
// matte-black legs with a square footrest, base on y = 0.
const OAK = "#c8975a";
const MATTE_BLACK = "#2e2e30";

export const barStool = defineModel({
  id: "bar-stool",
  batchId: "modern",
  name: "Bar stool",
  tags: ["modern", "interior", "furniture", "kitchen", "seating"],
  summary: "A bar stool with a round oak seat and slim matte-black legs.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const legs: Part[] = [];
    for (const x of [-0.115, 0.115]) {
      for (const z of [-0.115, 0.115]) {
        legs.push({
          geometry: new THREE.BoxGeometry(0.03, 0.62, 0.03),
          color: MATTE_BLACK,
          position: [x, 0.31, z],
        });
      }
    }
    return [
      // round oak seat (top surface at 0.65)
      { geometry: new THREE.CylinderGeometry(0.17, 0.17, 0.04, 20), color: OAK, position: [0, 0.63, 0] },
      ...legs,
      // square footrest ring
      { geometry: new THREE.BoxGeometry(0.23, 0.025, 0.025), color: MATTE_BLACK, position: [0, 0.2, 0.115] },
      { geometry: new THREE.BoxGeometry(0.23, 0.025, 0.025), color: MATTE_BLACK, position: [0, 0.2, -0.115] },
      { geometry: new THREE.BoxGeometry(0.025, 0.025, 0.23), color: MATTE_BLACK, position: [0.115, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.025, 0.025, 0.23), color: MATTE_BLACK, position: [-0.115, 0.2, 0] },
    ];
  },
  animations: [],
});
